export const darkTheme = {
    bg: "#1C1C27",
    bgLight: "#1C1E27",
    primary: "#854CE6",
    text_primary: "#F2F3F4",
    text_secondary: "#b1b2b3",
    card: "#171721",
    card_light: '#191924',
    button: "#854CE6",
    white: "#FFFFFF",
    black: "#000000",
    glass: "rgba(255, 255, 255, 0.05)",
    glassBorder: "rgba(255, 255, 255, 0.12)",
    navBg: "rgba(28, 28, 39, 0.7)",
    gradient: "linear-gradient(135deg, #854CE6 0%, #a855f7 50%, #6366f1 100%)",
    hover: "rgba(133, 76, 230, 0.1)",
}

export const lightTheme = {
    bg: "#FFFFFF",
    bgLight: "#f0f0f0",
    primary: "#be1adb",
    text_primary: "#111111",
    text_secondary: "#48494a",
    card: "#FFFFFF",
    button: "#5c5b5b",
    white: "#FFFFFF",
    black: "#000000",
    glass: "rgba(255, 255, 255, 0.6)",
    glassBorder: "rgba(200, 200, 230, 0.3)",
    navBg: "rgba(240, 240, 240, 0.8)",
    gradient: "linear-gradient(135deg, #be1adb 0%, #a855f7 50%, #6366f1 100%)",
    hover: "rgba(190, 26, 219, 0.08)",
}